import { render, staticRenderFns } from "./LoadingButtons.vue?vue&type=template&id=dde93e24&scoped=true&"
import script from "./LoadingButtons.vue?vue&type=script&lang=js&"
export * from "./LoadingButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde93e24",
  null
  
)

export default component.exports